// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"wrapper__2IhKX","wrapper-nopadding":"wrapper-nopadding__38z7s","loading":"loading__zsBv0","error":"error__n9hzj","table-loading":"table-loading__NakM8","empty-val":"empty-val__1TSoq","panelheader-tools":"panelheader-tools__3Erbc","propsPanels":"propsPanels__1Of2P","new":"new__3rfpS","marginLm":"marginLm__XtPJI","marginRm":"marginRm__1v9gi","fullWidth":"fullWidth__1Af1a","fullHeight":"fullHeight__1tujW","noData":"noData__2WUkb","result":"result__3e-mr","body":"body__3hubW","img":"img__2J2LY","footer":"footer__PQdf-"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/Register/coms/RegisterResult/styles.scss
// module id = 2319
// module chunks = 1